module.exports = __webpack_public_path__ + "img/9788932917313.c07cf4f5.jpg";